import React from 'react'
import styled from 'styled-components'

// import { RemarkModal } from './RemarkModal'
import { Input } from '../../../../input'
import { FONTS } from '../../../../../constants'

export const ThirdRow = React.memo(({ isEditing, data, progressIndex, index, handleRemark }) => {
  return (
    <Root>
      {/* { openRemarkModal &&
      <RemarkModal
        isOpen={ openRemarkModal }
        data={ data }
        type={ type }
        toggle={ handleClickRemark }
      />
      } */}
      <FormWrapper>
        <Label>Remark</Label>
        <Input
          placeholder='Enter Remark'
          disabled={ !isEditing }
          onChange={ e => handleRemark(e.target.value, progressIndex, index) }
          value={ data._remark || '' }
        />
      </FormWrapper>
      {/* <RemarkWrapper onClick={ handleClickRemark }>
        <AiOutlineMessage style={ { color: '#2D9CDB', marginRight: 8 } } />
        <RemarkText>Remark</RemarkText>
      </RemarkWrapper> */}
    </Root>
  )
})

const Root = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-right: 24px;
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #808080;

  ${p => p.required && `
    ::after {
      content: '*';
      color: red;
    }
  `}
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/detail/ThirdRow.js